<template>
  <a class="navbar-brand" id="sidebarToggle" href="#">
    <div class="row">
      <div class="col-md-4 col-sm-6">
        <img class="img-fluid mr-2" :src="krbsLogo"/>
        <span class="font-weight-bold">"KRBS TURNOVER NOTES SYSTEM"</span>
      </div>
    </div>
  </a>
</template>

<script>

import krbsLogo from '../../../../assets/krbsicon.png'

export default {
  name: "NavAppName",

  /** mixins **/
  mixins: [],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {
      krbsLogo : krbsLogo
    }
  },

  /** methods**/
  methods: {},

  /**  computed  **/
  computed: {},

  /** mounted **/
  mounted() {
  },

  /** created **/
  created() {
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
  },

}
</script>

<style scoped>
span{
  font-size: 1rem ; color : #FFFFFF !important;
}

img{
  max-height: 40px !important;
  max-width: 40px !important;
}
</style>
